module.exports = {
  // TODO: change your profile information here
  name: "Isha Goyal",
  greeting: "Hey 👋",
  greetingDescription: "I'm Isha goyal and I'm a Software Engineer!",
  githubUrl: "https://github.com/isha2199",
  linkedinUrl: "https://www.linkedin.com/in/isha-goyal-761617187/",
  cvLink: "https://drive.google.com/file/d/1kkVol82-JRnp8TaHf9mfP-NGW_kds155/view?usp=sharing",
};
